import Axios, { AxiosRequestConfig } from 'axios'

/**
 * Solo para desarrollo: permite usar los servicios del ambiente configurado en REACT_APP_HOST
 * (por ejemplo Periferia) y enviar únicamente las llamadas de ho-century-ws a otra URL
 * (por ejemplo el Century local). Se activa solo si REACT_APP_HOST_CENTURY tiene valor y nunca en producción.
 *
 *   REACT_APP_HOST_CENTURY=http://localhost:7001
 */
export const redirigirUrlCentury = (url: string | undefined, origen: string, destino: string): string | undefined => {
  if (!url || !origen || !destino || !url.startsWith(origen)) return url
  const resto = url.slice(origen.length)
  if (resto !== '' && !resto.startsWith('/') && !resto.startsWith('?')) return url
  return `${destino.replace(/\/+$/, '')}${resto}`
}

export const registrarRedireccionCenturyLocal = (): boolean => {
  const destino = process.env.REACT_APP_HOST_CENTURY
  const origen = `${process.env.REACT_APP_HOST ?? ''}${process.env.REACT_APP_CENTURY ?? ''}`
  if (!destino || process.env.NODE_ENV === 'production' || !process.env.REACT_APP_HOST || !process.env.REACT_APP_CENTURY) return false
  Axios.interceptors.request.use((configuracion: AxiosRequestConfig) => ({
    ...configuracion,
    url: redirigirUrlCentury(configuracion.url, origen, destino)
  }))
  // eslint-disable-next-line no-console
  console.info(`[DEV] Llamadas a ho-century-ws redirigidas de ${origen} a ${destino}`)
  return true
}
